<template>
  <div id="app">
    <LogisticsLayout></LogisticsLayout>
  </div>
</template>

<script>
import LogisticsLayout from './views/LogisticsLayout.vue'
export default {
  name: 'app',
  components: {
    LogisticsLayout
  }
}
</script>

<style lang="scss">
  // Adding styles to project
  @import 'node_modules/bootstrap/scss/bootstrap';
  @import 'node_modules/bootstrap-vue/src/index.scss';
  @import 'assets/scss/custom/_custom-styles.scss';
</style>
